import {isEmpty, find, toNumber} from 'lodash-es';

import {
  ENTER,
  UP_ARROW,
  DOWN_ARROW,
  ESCAPE,
  SPACE,
  TAB,
} from 'static/three-oh/src/constants/keyCodes.js';
import {
  GLOBAL_NAV_SEARCH_FORM_ID,
  CLASSNAME_FOR_JEEVES_GLOBAL_NAV_SUGGESTION,
} from 'static/three-oh/src/routes/Search/constants';

export const onSuggestionKeyDown = ({event, onSuggestionSubmit, onSuggestionDismiss, onSuggestionTab}) => {
  event.preventDefault();

  if (event.keyCode === ENTER || event.keyCode === SPACE) {
    onSuggestionSubmit();
  } else if (event.keyCode === ESCAPE) {
    onSuggestionDismiss();
  } else if (event.keyCode === TAB) {
    onSuggestionTab();
  }

  // Compile a list of the <li> tags (they all share a class name) that render
  // search suggestions in the global-nav search menu.
  const suggestions = document.querySelectorAll(`.${CLASSNAME_FOR_JEEVES_GLOBAL_NAV_SUGGESTION}`);

  // If there aren't any suggestions, there's nothing to navigate through. Bail.
  if (isEmpty(suggestions)) {
    return;
  }

  const currentSuggestion = find(Array.from(suggestions), (suggestion) => {
    return suggestion.getAttribute('data-index-number') === event.target.getAttribute('data-index-number');
  });
  const currentSuggestionIndexNumber = toNumber(currentSuggestion.getAttribute('data-index-number'));

  if (event.keyCode === DOWN_ARROW) {
    if (currentSuggestionIndexNumber === suggestions.length - 1) {
      // This is the last suggestion in the list. Per the current UX behavior,
      // do nothing. Users can use the 'up-arrow' key to cascade up the list.

    } else {
      // Else, apply focus to the next suggestion on the list.
      const newIndex = currentSuggestionIndexNumber + 1;
      suggestions[newIndex].focus();
    }
  } else if (event.keyCode === UP_ARROW) {
    const indexOfFirstSuggestion = 0;
    if (currentSuggestionIndexNumber === indexOfFirstSuggestion) {
      // This is the first suggestion in the list. If the 'up-arrow' key is
      // selected, apply focus to the search-form's input field.
      const inputFieldElement = document.getElementById(GLOBAL_NAV_SEARCH_FORM_ID);
      if (inputFieldElement) {
        inputFieldElement.focus();
      }
    } else {
      // Else, apply focus to the previous suggestion.
      suggestions[currentSuggestionIndexNumber - 1].focus();
    }
  }
};
